import { Button, Classes, Dialog, Intent } from '@blueprintjs/core'
import React, { SyntheticEvent } from 'react'

export default function ConfirmBox({
  isOpen,
  title,
  text,
  confirmButtonMsg = 'Confirm',
  cancelButtonMsg = 'Cancel',
  confirm,
  cancel,
  close,
  width = 400,
  contentHeight,
}: {
  isOpen: boolean
  title?: string
  text: string
  confirmButtonMsg?: string
  cancelButtonMsg?: string
  confirm: () => void
  cancel?: () => void
  close: (event: SyntheticEvent<HTMLElement> | undefined) => void
  width?: number
  contentHeight?: number
}) {
  return (
    <Dialog isOpen={isOpen} onClose={close} title={title} style={{ width: `${width}px` }}>
      <div className={Classes.DIALOG_BODY}>
        <p
          style={{
            overflowY: 'auto',
            height: (contentHeight && contentHeight) || 'auto',
          }}
        >
          {text}
        </p>
        <div className={Classes.DIALOG_FOOTER_ACTIONS} style={{ marginTop: '25px' }}>
          <Button
            intent={Intent.NONE}
            text={cancelButtonMsg}
            onClick={(ev: SyntheticEvent<HTMLElement>) => {
              cancel && cancel()
              close(ev)
            }}
          />
          <Button
            intent={Intent.PRIMARY}
            text={confirmButtonMsg}
            onClick={(ev: SyntheticEvent<HTMLElement>) => {
              confirm()
              close(ev)
            }}
          />
        </div>
      </div>
    </Dialog>
  )
}
